import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import { List, ListItem } from '@dbk/ui-list';
import { Radio } from '@dbk/ui-forms';
import Text from '@dbk/ui-text';
import { FormattedMessage } from '@dbk-legacy/format';
import currencyData from '../../data/currencylist.json';
import ScrollableLayout from '../../components/common/scrollable-layout';

class ProfileCurrencyOptions extends Component {
  async handlePress(currency) {
    const {changePage, i18n: {messages}, config: {regionCode}} = this.props;
    await this.props.currencies.onCurrencyPress({
       currency
    });

    changePage ({ pathname: '/profile' });
    
    if(regionCode !=='CH'){
      alert(messages['app.profile.currency.changeCurrencyMsg']);
    }
    
  }

  renderListItems = (item,index) => {
    const { i18n: { messages }, auth: {
      destinationCurrency,
      settingsDisabled
    } } = this.props;
    const { currency, country, key } = item;
    const selectedCurrency = (!destinationCurrency ? 'default' : destinationCurrency) === key;

    return(
      <ListItem onClick={() => !settingsDisabled ? this.handlePress(key) : null} className="profile__list-item" id={`listItem_viewCurrency_profileCurrencyOptions_test_${key}_${index}`}>
        <div className='profile__currency-option'>
          <Radio className='profile__radio-button' checked={selectedCurrency}  disabled={settingsDisabled}/>
         
            <Text className="currency__list-item-currency">{
              currency === 'Default' ? messages['app.profile.currency.default'] : currency
            }
            </Text>
            <div>
            <Text>
            {currency === 'Default' ? <FormattedMessage
                id={country} 
                values={{ BASE_CCY : this.props.userprofile.baseCurrency}}
                renderProps = {{
                  style: {whiteSpace: 'normal'}
                }}
              /> : messages[country]}
            </Text>
            </div>
        </div>
      </ListItem>
    );
  }

  renderCurrencyOptions = (currencyList) => {
    return (
      // <div className="consolidation__items-wrapper">
        <List className="profile__list" fullWidth>
        {
          currencyList.map((item,index) => {
            return this.renderListItems(item,index)
          })
        }
        </List>
      // </div>
    );
  }

  render() {
    const currencyList = currencyData.currencyList;

    const {
     i18n: { messages }
    } = this.props;

    return (
      <div>
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="row consolidation">
            <div className="columns small-12 large-12  profile-container">
              <div className="profile-container__title">
                <h2 id="text_viewCurrency_profileCurrencyOptions_test">{messages['app.common.pageTitle.viewCurrency']}</h2>
              </div>
              <div className="profile__content" id="list_viewCurrency_profileCurrencyOptions_test">
                <p className='profile__content-info'>{messages['app.profile.currencyHead']}</p>
                <div>
                  {this.renderCurrencyOptions(currencyList)}
                </div>
              </div>
            </div>            
          </div>         
        }
      />
       </div>
       
    )
  }
}

export default createContainer({
  $queries: {
    auth: {
      destinationCurrency: true,
      settingsDisabled: true
    },
    userprofile: {
      baseCurrency: true
    },
    currencies: {
      onCurrencyPress: { $call: 'saveCurrency' },
    },
    i18n: {
      messages: true
    },
    changePage: { $call: 'ui.history.push' }
  },
})(ProfileCurrencyOptions);
